<template>
    <div class="view pa24">
        <el-drawer :append-to-body="true" :modal-append-to-body="false" :visible.sync="drawer" :direction="direction"
            :before-close="closeDialog" @opened="onDialogOpened" size="15%">
            <template #title>
                <span class="custom-title">筛选条件</span>
            </template>
            <el-form :model="ruleForm" :rules="rules" ref="dealerRuleForm"  class="ruleFormruleForm">
                <el-form-item v-for="(item, index) in filterItems" :key="index" :label="item.label" :prop="item.prop">
                    <template slot="label">
                        <el-checkbox v-model="tempRuleForm[item.prop]" style="margin-right: 10px; margin-left: 10px;"></el-checkbox>
                        <span style="font-size: 14px; font-weight: 500;">{{ item.label }}</span>
                    </template>
                </el-form-item>
            </el-form>
            <div class="dialog-footer" style="text-align: right;">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button class="btncss" @click="confirmFilter">确 定</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
    import { getDeviceList, recycle, getDearler, getNoPage } from '@/api/gps.js'
    export default {
        data() {
            return {
                drawer: false,
                direction: 'rtl', // 设置抽屉从右侧弹出
                ruleForm: {},
                rules: {},
                tempRuleForm: {}, // 新增：用于临时存储用户的选择
                filterItems: [
                    { prop: 'deviceName', label: '设备名称' },
                    { prop: 'handle', label: '设备标识' },
                    { prop: 'dealerName', label: '经销商' },
                    { prop: 'deviceAddress', label: '绑定区域' },
                    { prop: 'orderNo', label: '绑定订单号' },
                    { prop: 'shipmentPlace', label: '发货地址' },
                    { prop: 'receiptPlace', label: '收货地址' },
                    { prop: 'status', label: '窜货状态' },
                    { prop: 'operator', label: '操作员' },
                    { prop: 'vbat', label: '设备电量' },
                    { prop: 'temp', label: '设备温度' },
                    { prop: 'imei', label: '设备IMEI号' },
                    { prop: 'iccid', label: '设备卡号' },
                    { prop: 'version', label: '设备版本号' },
                    { prop: 'isRecycle', label: '是否回收' },
                    { prop: 'createTime', label: '创建时间' },
                ],
            };
        },
        methods: {
            openDialog(type, data) {
                // this.ruleForm = {};
                this.drawer = true;
                this.tempRuleForm = { ...this.ruleForm };
            },
            closeDialog() {
                this.tempRuleForm={}
                this.drawer = false;
            },
            confirmFilter() {
                this.ruleForm = { ...this.tempRuleForm };
                this.$refs.dealerRuleForm.validate((valid) => {
                    if (valid) {
                        console.log('ruleForm:', this.ruleForm);
                        // 构建params
                        let params = { ...this.ruleForm };
                        // 调用API或更新父组件状态
                        console.log('params:', params); // 添加调试信息
                        this.updateParentList(params);
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            onDialogOpened() {
            },
            updateParentList(params) {
                // 更新父组件的列表数据
                this.$emit('update-list', params);
            },
        }
    };
</script>

<style scoped>
    .el-drawer {
        z-index: 9999;
        width: 30%;
        /* 根据需要调整宽度 */
    }

    .el-form-item__label {
        display: flex;
        align-items: center;
    }

    .el-form-item__label .el-checkbox {
        margin-right: 10px;
    }

    .el-form-item__label span {
        flex-grow: 1;
        text-align: left;
    }

    .custom-title {
        font-size: 18px;
        /* 设置字体大小 */
        font-weight: bold;
        /* 设置字体粗细 */
    }
</style>